import { IsBoolean, IsNotEmpty, IsString } from 'class-validator';

/**
 * @see backend-php/modules/rest_common/models/taxonomy/FieldReference.php
 */
export class FieldReferenceOptions {
    // идентификатор справочника на который ссылается это поле
    @IsString()
    @IsNotEmpty()
    public referenceUuid: string;

    // Разрешает множественный выбор, т.е. можно сохранить несколько идентификаторов записей справочника в массиве
    @IsBoolean()
    public multiple: boolean;

    constructor(data?: Partial<FieldReferenceOptions>) {
        this.referenceUuid = data?.referenceUuid;
        this.multiple = data?.multiple;
    }
}
